// Material lots (a TRK = one received pallet, jobq-api material_tracking): ONE copy of the lot read,
// used by the desktop TRK popup (components/MtnDetailModal.jsx) and the phone's lot panel
// (mobile/screens/BeaconsScreen.jsx).
import config from "../../config.js";

const API_BASE = config.API_BASE_URL;

/** GET /material_tracking/{id}: one lot. Rejects with the HTTP status text (the popup shows it). */
export async function loadLotDetail(mtnId) {
  const r = await fetch(`${API_BASE}/material_tracking/${mtnId}`);
  if (!r.ok) return Promise.reject(r.statusText);
  return r.json();
}

/** GET /material_tracking/{id}/usage: what was cut from the lot ([] when refused; a dropped connection rejects). */
export async function loadLotUsage(mtnId) {
  const r = await fetch(`${API_BASE}/material_tracking/${mtnId}/usage`);
  const rows = r.ok ? await r.json() : [];
  return Array.isArray(rows) ? rows : [];
}

/** GET /material_tracking/{id}/notes: the lot's notes ([] when unreadable). */
export async function loadLotNotes(mtnId) {
  try {
    const r = await fetch(`${API_BASE}/material_tracking/${mtnId}/notes`);
    const rows = r.ok ? await r.json() : [];
    return Array.isArray(rows) ? rows : [];
  } catch (_) {
    return [];
  }
}

const LOT_STATUS_LABEL = Object.freeze({
  unused: "Not started",
  active: "In use",
  on_hand: "On hand",
  exhausted: "Used up",
  returned: "Returned",
  transferred: "Transferred",
  over: "Count check: more used than received",
  reconciled: "Reconciled",
});

/** A lot status as words ('exhausted' -> 'Used up'); an unknown one as the API sent it. */
export function lotStatusLabel(status) {
  return LOT_STATUS_LABEL[status] || (status ? String(status) : "");
}
